module.exports = __webpack_public_path__ + "media/images/emblems/Andwil-SG-flago-7910b3fcaae0073a21848f4b3202d29b.png";